import {getStationCode}  from "../../network/NetworkUtil";
import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
import {logOperationalMetric} from "../../util/Util";
import {CAPABILITY} from "../../util/Constants";
import {chainWalk} from "../../util/Util";

/**
 * API call to fetch Receive Overview
 * @param filter
 * @param capability
 * @param dispatcher
 */
const metricProcessName = "SCC_RECEIVE";
export function fetchReceiveOverview(filter, capability, dispatcher, isCPTFilterEnabled) {

    let filterMap;

    if(isCPTFilterEnabled){
        filterMap = {
            [filter.filterIdentifier]: filter.allCPT
                .filter(CPT => filter.selectedCPT.includes(CPT.label))
                .map(CPT => CPT.id)

        };
    }
    else{
        filterMap = {
            "Cycle": filter.selectedCycles
        };
    }
    const request = {
        nodeId: getStationCode(),
        filters: filterMap,
        groupBy: 'Node',
        metricList: ["CURRENT_CYCLE_RECEIVED", "OTHER_CYCLE_RECEIVED",
            "PENDING_DEPART_FROM_UPSTREAM", "PENDING_DEPART_FROM_UPSTREAM_UNPLANNED", "IN_TRANSIT_FROM_UPSTREAM",
            "IN_TRANSIT_FROM_UPSTREAM_UNPLANNED", "PENDING_INDUCT", "PENDING_INDUCT_UNPLANNED", "PENDING_RE_INDUCT",
            "PENDING_RE_INDUCT_UNPLANNED", "INDUCTED_AT_STATION", "PLANNED_MANIFESTED",]
    }

    if (CAPABILITY.AR_NEXT_GEN === capability) {
        request.metricList.push("PROBLEM_SOLVE")
    } else {
        request.metricList.push("SIDELINE")
    }
    getPackageMetrics(dispatcher, request, isCPTFilterEnabled);
    fetchContainerPlannedNumber(filter.selectedCPT, filter.allCPT, filter.selectedCycles, filter.allCycles, filter.filterIdentifier, dispatcher, isCPTFilterEnabled);
    fetchStowNumber(filter.selectedCPT, filter.allCPT, filter.selectedCycles,filter.filterIdentifier,dispatcher, isCPTFilterEnabled);
}

function getCPTDataAPIGatewayRequest(request) {
    return {
        resourcePath: "/ivs/getStationCPTs",
        httpMethod: "post",
        processName: "induct",
        requestBody: request
    }
}

export function fetchCPTList(dispatcher) {

    const request = {
        nodeId: getStationCode(),
    }
    const args = getCPTDataAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getCPTData", true);
            const output = result.data;
            let data= JSON.parse(output.CPTList).filter(CPT => CPT.label !== 'ALL')
            const unplanned = {
                id: "ALL",
                label: "ALL"
            }
            data = [...data, unplanned]
            dispatcher({type: "RECEIVE_CPT", data: {CPT: data}})
            dispatcher({type: "ASSIGN_LABEL", data: {CPTLabel: output.CPTTypeLabelKey}})
            dispatcher({type: "ASSIGN_FILTER_IDENTIFIER", data: {filterIdentifier: output.filterIdentifier}})
        } else {
            logOperationalMetric(startTime, metricProcessName, "getCPTData", false);
        }
    });
}

function getReceiveAPIGatewayRequest(request) {
    return {
        resourcePath: "/ivs/getPackageMetric",
        httpMethod: "post",
        processName: "induct",
        requestBody: request
    }
}

async function getPackageMetrics(dispatcher, request) {
    const args = getReceiveAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getPackageMetrics", true);
            const output = result.data.groupedPackageMetrics
            const stationCode = getStationCode()
            const defaultCount = 0
            const sideLined = chainWalk(() => (output.SIDELINE)[stationCode], defaultCount)
            dispatcher({type: "RECEIVE_DATA", data: {
                    total_predicated_plan: (output.PLANNED_MANIFESTED)[stationCode],
                    actual_volume: (output.CURRENT_CYCLE_RECEIVED)[stationCode],
                    other_volume: (output.OTHER_CYCLE_RECEIVED)[stationCode],
                    actual_total_volume: ((output.CURRENT_CYCLE_RECEIVED)[stationCode] + (output.OTHER_CYCLE_RECEIVED)[stationCode]),
                    actual_pending_depart_from_upstream: (output.PENDING_DEPART_FROM_UPSTREAM)[stationCode],
                    actual_pending_depart_from_upstream_unplanned: (output.PENDING_DEPART_FROM_UPSTREAM_UNPLANNED)[stationCode],
                    actual_in_transit_from_upstream: (output.IN_TRANSIT_FROM_UPSTREAM)[stationCode],
                    actual_in_transit_from_upstream_unplanned: (output.IN_TRANSIT_FROM_UPSTREAM_UNPLANNED)[stationCode],
                    actual_pending_induct: (output.PENDING_INDUCT)[stationCode],
                    actual_pending_induct_unplanned: (output.PENDING_INDUCT_UNPLANNED)[stationCode],
                    actual_pending_re_induct: (output.PENDING_RE_INDUCT)[stationCode],
                    actual_pending_re_induct_unplanned: (output.PENDING_RE_INDUCT_UNPLANNED)[stationCode],
                    actual_inducted: (output.INDUCTED_AT_STATION)[stationCode],
                    actual_sidelined: sideLined,
                    problem_solve: chainWalk(() => (output.PROBLEM_SOLVE)[stationCode], defaultCount)
                }});
        } else {
            logOperationalMetric(startTime,metricProcessName, "getPackageMetrics", false);
        }
    });
}

function fetchStowNumber(CPTFilter, CPTDetail, cycleFilter, filterIdentifier, dispatcher, isCPTFilterEnabled)  {
    let requestFilter;
    if (cycleFilter.length > 0 && !isCPTFilterEnabled) {
        requestFilter = {
            NODE: [getStationCode()],
            CYCLE: cycleFilter
        }
    } else if(CPTFilter.length > 0 && isCPTFilterEnabled) {
        requestFilter = {
            NODE: [getStationCode()],
            [filterIdentifier]: CPTDetail
                .filter(CPT => CPTFilter.includes(CPT.label))
                .map(CPT => CPT.id)
        }
    } else {
        requestFilter = {
            NODE: [getStationCode()]
        }
    }
    const request = {
        filters: requestFilter,
        groupBy: 'NONE',
        metrics: ["CURRENT_STOWED_COUNT", "CURRENT_STOW_BUFFERED_COUNT"]
    }
    getStowMetrics(dispatcher, request);
}

function fetchContainerPlannedNumber(CPTFilter, CPTDetails, cycleFilter, cycleDetails, filterIdentifier,dispatcher, isCPTFilterEnabled)  {

    let requestFilter;
    if (cycleFilter.length > 0 && !isCPTFilterEnabled) {
        requestFilter = {
            NODE: [getStationCode()],
            CYCLE_ID: cycleDetails
                .filter(cycleDetail => cycleFilter.includes(cycleDetail.cycleId))
                .map(cycleDetail => cycleDetail.casCycleId)
        }
    } else if(CPTFilter.length > 0 && isCPTFilterEnabled) {
        requestFilter = {
            NODE: [getStationCode()],
            [filterIdentifier]: CPTDetails
                .filter(CPT => CPTFilter.includes(CPT.label))
                .map(CPT => CPT.id)
        }
    } else {
        dispatcher({
            type: "RECEIVE_PLANNED_DATA", data: {
                planned_volume: '0'
            }
        });
    }

    const request = {
        filters: requestFilter,
        groupBy: 'NODE',
        metrics: ["PLANNED_COUNT"]
    }
    getContainerPlannedMetrics(dispatcher, request);
}

function getStowAPIGatewayRequest(request) {
    return {
        resourcePath: "svs/packages/metrics",
        httpMethod: "post",
        processName: "stow",
        requestBody: request
    }
}

async function getStowMetrics(dispatcher, request) {
    const args = getStowAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getStowData", true);
            const output = result.data.groupedPackageMetrics
            dispatcher({type: "RECEIVE_STOW_DATA", data: {
                actual_stowed: output["Total"] && (output["Total"]).currentStowedCount,
                actual_stow_buffered: output["Total"] && (output["Total"]).currentStowBufferedCount
            }});
        } else {
            logOperationalMetric(startTime, metricProcessName, "getStowData", false);
        }
    });
}

async function getContainerPlannedMetrics(dispatcher, request) {
    const args = getStowAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getContainerPlannedMetric", true);
            const output = result.data.groupedPackageMetrics
            const stationCode = getStationCode()
            dispatcher({
                type: "RECEIVE_PLANNED_DATA", data: {
                    planned_volume: (output[stationCode]) ? (output[stationCode]).plannedCount : '0'
                }
            });
        } else {
            logOperationalMetric(startTime, metricProcessName, "getContainerPlannedMetric", false);
        }
    });
}

export function fetchCPTDetails(dispatcher,capability) {
    const request = {
        nodeId: getStationCode(),
    }
    const args = getCPTDataAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getCPTData", true);
            const output = result.data;
            dispatcher({
                type: 'INITIALIZE_CPT_FILTER_ENABLED_GROUPS',
                data: {
                    capability: capability,
                    CPTLabel: output.CPTTypeLabelKey,
                    filterIdentifier: output.filterIdentifier
                }
            });
        } else {
            logOperationalMetric(startTime, metricProcessName, "getCPTData", false);
        }
    });

}


// WEBPACK FOOTER //
// ./src/components/receive/network/ReceiveNetworkAPI.js